import { formatToUSDateTimeWith12Hour } from 'utils/dateTimeUtils/dateFormatUtil';

import FarmsGridRowWrapper from 'components/FarmsGrid/components/FarmsGridRowWrapper';
import GridText from 'components/text/GridText';
import TableLink from 'components/text/TableLink';

import usePageRoutes from 'hooks/usePageRoutes';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const FarmsGridRow = ({
    id,
    lastActivity,
    lastEdited,
    name,
    ref,
    style,
    testId = TEST_ID
}: Props) => {
    const { farmDetailsPage } = usePageRoutes();

    return (
        <FarmsGridRowWrapper ref={ref} style={style} testId={testId}>
            <TableLink className={styles.tableLink} text={name} to={farmDetailsPage(id)} />

            <GridText text={formatToUSDateTimeWith12Hour(lastEdited) ?? '-'} />

            <GridText text={lastActivity ?? '-'} />
        </FarmsGridRowWrapper>
    );
};

export default FarmsGridRow;
